// extracted by mini-css-extract-plugin
export default {"faq":"Faq_faq__emvT6","faq__list":"Faq_faq__list__uhsd4","faq__item":"Faq_faq__item__NtUUH","faq__answer":"Faq_faq__answer__FufZH"};